import { axiosAPIInstance as axios } from '../../axios-config';

const swap = (arr, i, j) => {
  const temp = arr[i];
  arr[i] = arr[j];
  arr[j] = temp;
};

const shuffle = (arr) => {
  for (let i = 0; i < arr.length; ++i) {
    const randomIndex = Math.floor(Math.random() * (arr.length - i)) + i;
    swap(arr, i, randomIndex);
  }
  return arr;
};

const state = {
  // Fix to cache the game length and prevent unnecessary calls
  lastComputedBranchLengthGame: null,
  // This is a hack to skip over the watchers in the Dashboard during the wait period in multiplayer
  dashboardProcessingTickDelay: false,
  // This is used for the top level component refreshing
  gameRefreshKey: 0,
  isWaiting: false,
  updateGroup: false,
  demo: false,
  tempSelectedRole: {},
  slowZoom: false,
  requiredAssets: [],
  challenges: {},
  characters: {},
  game: {},
  group: {},
  individualDecisions: {},
  metrics: {},
  outro: {},
  roles: {},
  teamDecisions: {},
  users: {},
  lastStateBeforeChallengeIntro: undefined,
  teamDecisionBeginCash: 0,
  teamDecisionBeginMetrics: [],
  teamDecisionUpdated: false,
  resultsViewed: true,
  proxyRoleId: undefined,
  dateActiveGameCompleted: undefined,
  maxBranchLength: 0,
  lastChoice: undefined,
  skipOutrosEnabled: false,
  /** flag to let the Dashboard.vue know that navigating there happened due to hitting a Back button */
  backToDashboard: false,
};

const getMergedIdMapFromArray = (oldMap, array) => {
  const update = Object.assign({}, oldMap);
  array.forEach((item) => {
    update[item._id] = item;
  });
  return update;
};

const mutations = {
  /* eslint-disable max-len */

  setRequiredAssets(state, assetList) {
    state.requiredAssets = assetList;
  },

  // Enables the hack to skip over watchers in the dashboard after waiting in multiplayer.  Expects a boolean.
  setDashboardProcessingTickDelay(state, value) { state.dashboardProcessingTickDelay = value; },

  // Increments the router-view key in App.vue to refresh the active view
  refreshActiveView(state) {
    state.gameRefreshKey += 1;
  },

  // Sets whether or not the local user in a multiplayer game is waiting for another player to make a decision
  setIsWaiting(state, value) { state.isWaiting = value; },
  setUpdateGroup(state, { updateGroup = false }) { state.updateGroup = updateGroup; },
  setDemo(state, { demo }) { state.demo = demo; },
  setSkipOutros(state, { skipOutrosEnabled }) { state.skipOutrosEnabled = skipOutrosEnabled; },
  setTempSelectedRole(state, { selectedRole = {} }) { state.tempSelectedRole = selectedRole; },
  setSlowZoom(state, { slowZoom = false }) { state.slowZoom = slowZoom; },
  setLastStateBeforeChallengeIntro(state, { lastStateBeforeChallengeIntro }) { state.lastStateBeforeChallengeIntro = lastStateBeforeChallengeIntro; },
  setTeamDecisionUpdated(state, { teamDecisionUpdated }) { state.teamDecisionUpdated = !!teamDecisionUpdated; },
  setResultsViewed(state, { resultsViewed }) { state.resultsViewed = resultsViewed; },
  setProxyRole(state, { _id }) { state.proxyRoleId = _id; },
  setGame(state, { game }) { state.game = game; },
  setOutro(state, { outro }) { state.outro = outro; },
  setGroup(state, { group }) { state.group = group; },
  /* eslint-enable max-len */
  setChallenges(state, { challenges = [] }) {
    state.challenges = getMergedIdMapFromArray(state.challenges, challenges);
  },
  setCharacters(state, { characters = [] }) {
    state.characters = getMergedIdMapFromArray(state.characters, characters);
    // preloadAssetsFromObject(state.characters, true);
  },
  setIndividualDecisions(state, { individualDecisions = [] }) {
    state.individualDecisions =
      getMergedIdMapFromArray(state.individualDecisions, individualDecisions);
  },
  setMetrics(state, { metrics = [] }) {
    state.metrics = getMergedIdMapFromArray(state.metrics, metrics);
  },
  setRoles(state, { roles = [] }) {
    state.roles = getMergedIdMapFromArray(state.roles, roles);
  },
  setTeamDecisions(state, { teamDecisions = [] }) {
    state.teamDecisions = getMergedIdMapFromArray(state.teamDecisions, teamDecisions);
    // preloadAssetsFromObject(state.teamDecisions, true);
  },
  setUsers(state, { users = [] }) {
    state.users = getMergedIdMapFromArray(state.users, users);
  },
  setDateActiveGameCompleted(state, { dateActiveGameCompleted }) {
    state.dateActiveGameCompleted = dateActiveGameCompleted;
  },
  setMaxBranchLength(state, { maxBranchLength, gameId }) {
    state.maxBranchLength = maxBranchLength;
    if (gameId) {
      state.lastComputedBranchLengthGame = gameId;
    }
  },
  setLastChoice(state, { lastChoice }) {
    state.lastChoice = lastChoice;
  },
  setBackToDashboard(state, { backToDashboard = true } = {}) {
    state.backToDashboard = backToDashboard;
  },
};

const actions = {
  setTeamDecisionBeginMetrics({ getters: { playerGroupRole } }) {
    state.teamDecisionBeginMetrics = JSON.parse(JSON.stringify(state.group.metrics));

    // Currently disabled, left this here in case we want to use it later
    // eslint-disable-next-line no-constant-condition
    if (false && playerGroupRole && playerGroupRole.useRoleCash) {
      // state.teamDecisionBeginCash = playerGroupRole.cash;
    } else {
      state.teamDecisionBeginCash =
        state.group.cash;/* +
        state.group.roles.reduce((acc, { cash = 0 }) => acc + cash, 0); */
    }
  },
  startDemo({ commit }) {
    commit('setDemo', { demo: true });
  },
  exitDemo({ commit }) {
    commit('setDemo', { demo: false });
  },
  // temp role select for background update
  setTempSelectedRole({ commit }, { selectedRole = {} }) {
    commit('setTempSelectedRole', { selectedRole });
  },
  setSlowZoom({ commit }, { slowZoom = false }) {
    commit('setSlowZoom', { slowZoom });
  },
  setLastStateBeforeChallengeIntro({ commit }, { lastStateBeforeChallengeIntro }) {
    commit('setLastStateBeforeChallengeIntro', { lastStateBeforeChallengeIntro });
  },
  resetLastStateBeforeChallengeIntro({ commit }) {
    commit('setLastStateBeforeChallengeIntro', { lastStateBeforeChallengeIntro: '' });
  },
  setProxyRole({ commit }, { _id }) {
    commit('setProxyRole', { _id });
  },
  resetProxyRole({ commit }) {
    commit('setProxyRole', { _id: undefined });
  },
  setResultsViewed({ commit, getters, dispatch }) {
    const { complete, firstDecisionOfNewChallenge } = getters;
    if (!complete && !firstDecisionOfNewChallenge) {
      dispatch('setTeamDecisionBeginMetrics');
    }
    commit('setResultsViewed', { resultsViewed: true });
  },
  // wrapper that also clears flag on socket store
  setGroup({ commit, dispatch }, { group }) {
    if (group.requiredAssets) {
      commit('setRequiredAssets', group.requiredAssets);
    }
    commit('setGroup', { group });
    commit('setUpdateGroup', { updateGroup: false });
    dispatch('getActiveEnvironment');
  },
  /** DEPRECATED */
  async resetDemo() {
    await axios.delete('/game/demo');
    return Promise.resolve();
  },
  /** archive group by id; if no id specified, uses active group. */
  async archiveGroup({ getters: { group } }, { groupId } = {}) {
    const gid = ((groupId != null) ? groupId : group._id);
    await axios.delete(`/game/groups/${gid}`);
  },
  async archiveMyGroup(_, { gameId, classId } = {}) {
    await axios.post('/game/mygroup/archive', {
      gameId, classId
    });
  },
  async getMyGroups() {
    const { data: { groups, games } } = await axios.get('/game/groups/me');
    return { groups, games };
  },
  async getMyGroupIdOnly(_, {
    groupId,
    gameId,
    classId,
  } = {}) {
    if (groupId) return groupId;
    try {
      const res = (await axios.post('/game/mygroup/id', {
        gameId, classId
      }));
      if (res && res.data) {
        return res.data.groupId;
      }
    } catch (err) {
      return null;
    }
  },
  // gameId for admin demo launch; nothing for player demo launch
  // groupId for group launch
  async getMyGroup({
    commit,
    dispatch,
    getters,
  }, {
    groupId,
    gameId,
    classId,
    requestCompleted,
    path,
  } = {}) {
    const { group: oldGroup, groupTeamDecision } = getters;
    const route =
      groupId
        ? `/game/groups/${groupId}`
        : (gameId
          ? (classId
            ? `/game/demo/${gameId}?classId=${classId}${requestCompleted ? '&requestCompleted=true' : ''}`
            : `/game/demo/${gameId}${requestCompleted ? '?requestCompleted=true' : ''}`)
          : '/game/demo');
    const {
      data: {
        challenges,
        characters,
        chatMessages,
        activeClass,
        game,
        group,
        individualDecisions,
        metrics,
        outro,
        roles,
        requiredAssets,
        teamDecisions,
        users
      }
    } = await axios.get(route);

    if (group == null) {
      return;
    }

    commit('setRequiredAssets', requiredAssets);

    if (game.carryOverMetricsFromActive && group.dateActiveGameCompleted != null) {
      commit('setDateActiveGameCompleted', { dateActiveGameCompleted: group.dateActiveGameCompleted });
    } else if (!game.carryOverMetricsFromActive) {
      commit('setDateActiveGameCompleted', { dateActiveGameCompleted: undefined });
    }
    commit('setChallenges', { challenges });
    commit('setCharacters', { characters });
    commit('setChatMessages', { chatMessages });
    commit('setActiveClass', activeClass);
    commit('setGame', { game });
    commit('setOutro', { outro });
    const dispatches = [];
    if (game != null && (!path || path.includes('/groups/'))) {
      dispatches.push(dispatch('computeMaxBranchLength', { gameId: game._id }));
    }
    commit('setIndividualDecisions', { individualDecisions });
    commit('setMetrics', { metrics });
    commit('setRoles', { roles });
    commit('setTeamDecisions', { teamDecisions });
    commit('setUsers', { users });
    if (oldGroup && groupTeamDecision && groupTeamDecision._id) {
      const decisionIndex =
        (group.decisionIndex == null) ? (group.teamDecisions.length - 1) : group.decisionIndex;
      const newCurrentTeamDecision = group.teamDecisions[decisionIndex];
      const teamDecisionUpdated =
        (newCurrentTeamDecision && newCurrentTeamDecision._id !== groupTeamDecision._id);
      commit('setTeamDecisionUpdated', { teamDecisionUpdated });
    }
    dispatches.push(dispatch('setGroup', { group }));
    dispatches.push(dispatch('setTeamDecisionBeginMetrics'));
    commit('setDemo', { demo: group.demo });
    dispatches.push(dispatch('getActiveEnvironment', { path }));
    /*
    if (oldGroup._id !== group._id) {
      dispatches.push(dispatch('leaveGroupRoom', oldGroup));
      dispatches.push(dispatch('joinGroupRoom', group));
    } */
    await Promise.all(dispatches);
  },
  // TODO: duplicated code from above; should refactor out common code to a common action/mutation
  async pollGroup({ commit, dispatch, getters }, { groupId } = {}) {
    // alert('pollGroup');
    const { group: oldGroup, groupTeamDecision } = getters;
    const gid = ((groupId != null) ? groupId : oldGroup._id);
    const clientTimestamp = oldGroup.updated;
    const {
      data: {
        challenges,
        characters,
        chatMessages,
        activeClass,
        game,
        group,
        individualDecisions,
        metrics,
        outro,
        roles,
        teamDecisions,
        users
      }
    } = await axios.get(`/game/groups/${gid}/poll`, {
      params: {
        clientTimestamp,
        nocache: Date.now()
      }
    });

    // eslint-disable-next-line eqeqeq
    if (group == null || group.updated == null || group.updated == clientTimestamp) {
      return;
    }

    if (game.carryOverMetricsFromActive && group.dateActiveGameCompleted != null) {
      commit('setDateActiveGameCompleted', { dateActiveGameCompleted: group.dateActiveGameCompleted });
    } else if (!game.carryOverMetricsFromActive) {
      commit('setDateActiveGameCompleted', { dateActiveGameCompleted: undefined });
    }
    commit('setChallenges', { challenges });
    commit('setCharacters', { characters });
    commit('setChatMessages', { chatMessages });
    commit('setActiveClass', activeClass);
    commit('setGame', { game });
    commit('setOutro', { outro });
    const dispatches = [];
    if (game != null) {
      dispatches.push(dispatch('computeMaxBranchLength', { gameId: game._id }));
    }
    commit('setIndividualDecisions', { individualDecisions });
    commit('setMetrics', { metrics });
    commit('setRoles', { roles });
    commit('setTeamDecisions', { teamDecisions });
    commit('setUsers', { users });
    if (oldGroup && groupTeamDecision && groupTeamDecision._id) {
      const decisionIndex =
        (group.decisionIndex == null) ? (group.teamDecisions.length - 1) : group.decisionIndex;
      const newCurrentTeamDecision = group.teamDecisions[decisionIndex];
      const teamDecisionUpdated =
        (newCurrentTeamDecision && newCurrentTeamDecision._id !== groupTeamDecision._id);
      commit('setTeamDecisionUpdated', { teamDecisionUpdated });
    }
    dispatches.push(dispatch('setGroup', { group }));
    // dispatches.push(dispatch('setTeamDecisionBeginMetrics'));
    commit('setDemo', { demo: group.demo });
    dispatches.push(dispatch('getActiveEnvironment'));
    /* if (oldGroup._id !== group._id) {
      dispatches.push(dispatch('leaveGroupRoom', oldGroup));
      dispatches.push(dispatch('joinGroupRoom', group));
    } */
    await Promise.all(dispatches);
  },
  async selectBackstory({ dispatch, getters }, { backstory: { _id: backstoryId } }) {
    const { group: { _id: groupId } } = getters;
    const { data: { group } } = await axios.post(`/game/groups/${groupId}/backstories/${backstoryId}`);
    await dispatch('getMyGroup', { groupId: group._id });
  },
  async selectAvatar({ dispatch, getters }, { avatar: { _id: characterId } }) {
    const { group: { _id: groupId } } = getters;
    const { data: { group } } = await axios.post(`/game/groups/${groupId}/avatars/${characterId}`);
    dispatch('setGroup', { group });
    return Promise.resolve();
  },
  async selectRole({ dispatch, getters }, { role: { _id: roleId } }) {
    const { group: { _id: groupId } } = getters;
    const { data: { group } } = await axios.post(`/game/groups/${groupId}/roles/${roleId}`);
    dispatch('setGroup', { group });
    return Promise.resolve();
  },
  async setUnreadNotificationCount({ dispatch, getters }, count = 0) {
    const { group: { _id: groupId } } = getters;
    const { data: { group } } =
      await axios.patch(`/game/groups/${groupId}/unread-notification-count`, null, {
        params: {
          count
        }
      });
    await dispatch('setGroup', { group });
  },
  async setCurrentChallengeIntroViewed({ dispatch, getters }) {
    const { challenge, challengeIntroViewed, group: { _id: groupId } } = getters;
    if (!challengeIntroViewed) {
      const { data: { group } } =
        await axios.patch(`/game/groups/${groupId}/challenges/${challenge._id}/intro-viewed`);
      dispatch('setGroup', { group });
    }
    return Promise.resolve();
  },
  // NOTE: this route now doubles as role switching for single player mode
  // Therefore, the full state must be refreshed after this route is called.
  // This does not apply to setCurrentChallengeOutroViewed, because that is
  // only called on the last challenge and there can be no role switch.
  // In the case of no role switching, this extra fetch will be unnecessary.
  async setLastChallengeOutroViewed({ dispatch, getters }) {
    const {
      lastChallenge,
      lastChallengeOutroViewed,
      group: { _id: groupId, game: gameId }
    } = getters;

    if (lastChallenge && !lastChallengeOutroViewed) {
      const { data: { group: newGroup } } =
        await axios.patch(`/game/groups/${groupId}/challenges/${lastChallenge._id}/outro-viewed`);
      const newRole = newGroup.roles.find(({ player }) => `${getters.me._id}` === `${player}`);
      if (!newRole || `${newRole._id}` !== `${getters.playerGroupRole._id}`) {
        return dispatch('getMyGroup', { groupId, gameId });
      }
      dispatch('setGroup', { group: newGroup });
    }
    return Promise.resolve();
  },
  async setCurrentChallengeOutroViewed({ dispatch, getters }) {
    const { challenge, challengeOutroViewed, group: { _id: groupId } } = getters;
    if (!challengeOutroViewed) {
      const { data: { group } } =
        await axios.patch(`/game/groups/${groupId}/challenges/${challenge._id}/outro-viewed`);
      dispatch('setGroup', { group });
    }
    return Promise.resolve();
  },
  async setGameIntroViewed({ dispatch, getters }) {
    const { gameIntroViewed, group: { _id: groupId } } = getters;
    if (!gameIntroViewed) {
      const { data: { group } } = await axios.patch(`/game/groups/${groupId}/intro-viewed`);
      dispatch('setGroup', { group });
    }
    return Promise.resolve();
  },
  async setGameOutroViewed({ dispatch, getters }) {
    const { gameOutroViewed, group: { _id: groupId } } = getters;
    if (!gameOutroViewed) {
      const { data: { group } } = await axios.patch(`/game/groups/${groupId}/outro-viewed`);
      dispatch('setGroup', { group });
    }
    return Promise.resolve();
  },
  async setAvatarSelectOutroViewed({ dispatch, getters }) {
    const { avatarSelectOutroViewed, group: { _id: groupId } } = getters;
    if (!avatarSelectOutroViewed) {
      const { data: { group } } = await axios.patch(`/game/groups/${groupId}/avatar-select-outro-viewed`);
      dispatch('setGroup', { group });
    }
    return Promise.resolve();
  },
  async setRoleSelectOutroViewed({ dispatch, getters }) {
    const { roleSelectOutroViewed, group: { _id: groupId } } = getters;
    if (!roleSelectOutroViewed) {
      const { data: { group } } = await axios.patch(`/game/groups/${groupId}/role-select-outro-viewed`);
      dispatch('setGroup', { group });
    }
    return Promise.resolve();
  },
  async saveLastBackground({ dispatch, getters, rootGetters }) {
    const { group: { _id: groupId } } = getters;
    const { lastBackground = '' } = rootGetters;
    const { data: { group } } = await axios.patch(`/game/groups/${groupId}/last-background`, { background: lastBackground });
    dispatch('setGroup', { group });
    return Promise.resolve();
  },
  async saveBackgroundAudio({ dispatch, getters, rootGetters }) {
    const { group: { _id: groupId } } = getters;
    const { narrative = {} } = rootGetters;
    const data = {};
    if (narrative.backgroundAudioChange) data.currentBackgroundAudio = narrative.backgroundAudioChange;
    if (narrative.backgroundAudioChange && narrative.backgroundAudioLoopingChange != null) {
      data.currentBackgroundAudioLooping = narrative.backgroundAudioLoopingChange;
    }
    if (narrative.backgroundAudioVolumeChange) data.currentBackgroundAudioVolume = narrative.backgroundAudioVolumeChange;
    const { data: { group } } = await axios.patch(`/game/groups/${groupId}/background-audio`, data);
    dispatch('setGroup', { group });
    return Promise.resolve();
  },
  async setTeamDecisionStarted({ dispatch, getters }) {
    const { teamDecision, playerDecision, playerGroupDecision, group: { _id: groupId } } = getters;
    if (teamDecision && teamDecision._id
      && playerDecision && playerDecision._id
      && playerGroupDecision && !(playerGroupDecision.started)) { // not already set
      const { data: { group } } = await axios.patch(`/game/groups/${groupId}/team-decisions/${teamDecision._id}/decisions/${playerDecision._id}/started`);
      await dispatch('setGroup', { group });
    }
  },
  async submitTeamDecision({ commit, dispatch, getters, rootGetters: { ltiContext } },
    { decision = { _id: null }, choices = [], reason = '', duration = 0 }) {
    const { teamDecision, groupTeamDecision, group: { _id: groupId }, lastChoice } = getters;
    const body = { choices, reason, duration };
    if (ltiContext) {
      body.lti_context = ltiContext;
    }
    const {
      data: {
        group,
        characters,
        individualDecisions,
        teamDecisions
      }
    } = await axios.post(
      `/game/groups/${groupId}/team-decisions/${teamDecision._id}/decisions/${decision._id}`,
      body
    );

    const newGroup = JSON.parse(JSON.stringify(group));
    const decisionIndex =
      (newGroup.decisionIndex == null)
        ? (newGroup.teamDecisions.length - 1)
        : newGroup.decisionIndex;
    const newCurrentTeamDecision = newGroup.teamDecisions[decisionIndex];
    const teamDecisionUpdated =
      newCurrentTeamDecision && newCurrentTeamDecision._id !== groupTeamDecision._id;
    commit('setTeamDecisionUpdated', { teamDecisionUpdated });
    if (!lastChoice || !(lastChoice.wrong)) {
      commit('setResultsViewed', { resultsViewed: false });
    }

    commit('setCharacters', { characters });
    commit('setIndividualDecisions', { individualDecisions });
    commit('setTeamDecisions', { teamDecisions });
    await dispatch('setGroup', { group });
  },
  async submitDecisionless({ commit, dispatch }) {
    commit('setLastChoice', { lastChoice: null });
    return dispatch('submitTeamDecision', {});
  },
  async submitChoice({ commit, dispatch }, { decision, choice, reason = '', duration = 0 }) {
    commit('setLastChoice', { lastChoice: choice });
    const choices = [{ _id: choice._id }];
    return dispatch('submitTeamDecision', { decision, choices, reason, duration });
  },
  async submitMultiselect({ commit, dispatch }, { decision, selectedChoices, reason = '', duration = 0 }) {
    commit('setLastChoice', { lastChoice: selectedChoices });
    const choices = selectedChoices.map(c => ({ _id: c._id }));
    return dispatch('submitTeamDecision', { decision, choices, reason, duration });
  },
  async submitSliders({ commit, dispatch }, { decision, selectedChoices, reason = '', duration = 0 }) {
    commit('setLastChoice', { lastChoice: selectedChoices });
    const choices = selectedChoices.map(c => ({ _id: c._id, sliderValue: c.sliderValue }));
    return dispatch('submitTeamDecision', { decision, choices, reason, duration });
  },
  async submitScale({ commit, dispatch }, { decision, selectedChoices, reason = '', duration = 0 }) {
    commit('setLastChoice', { lastChoice: selectedChoices });
    const choices = selectedChoices.map(c => ({ _id: c._id, categoryId: c.category._id }));
    return dispatch('submitTeamDecision', { decision, choices, reason, duration });
  },
  async submitMatrix({ commit, dispatch }, { decision, selectedChoices, reason = '', duration = 0 }) {
    commit('setLastChoice', { lastChoice: selectedChoices });
    const choices = selectedChoices.map(c => ({ _id: c._id, categoryIds: c.categories.map(cat => ({ _id: cat._id })) }));
    return dispatch('submitTeamDecision', { decision, choices, reason, duration });
  },
  async submitMatching({ commit, dispatch }, { decision, selectedChoices, reason = '', duration = 0 }) {
    commit('setLastChoice', { lastChoice: selectedChoices });
    const choices = selectedChoices.map(c => ({ _id: c._id, categoryId: c.category._id }));
    return dispatch('submitTeamDecision', { decision, choices, reason, duration });
  },
  async submitAllocation({ commit, dispatch }, { decision, choices, reason = '', duration = 0 }) {
    commit('setLastChoice', { lastChoice: null });
    return dispatch('submitTeamDecision', { decision, choices, reason, duration });
  },
  async submitDecisionForm({ commit, dispatch }, { decision, choices, reason = '', duration = 0 }) {
    commit('setLastChoice', { lastChoice: null });
    return dispatch('submitTeamDecision', { decision, choices, reason, duration });
  },
  async submitIndividualDecision({ commit, dispatch, getters }, { choice, reason = '', duration = 0 }) {
    commit('setLastChoice', { lastChoice: choice });
    const choices = [{ _id: choice._id }];
    const { individualDecision, group: { _id: groupId } } = getters;
    const {
      data: {
        group,
        characters,
        individualDecisions,
        teamDecisions
      }
    } = await axios.post(
      `/game/groups/${groupId}/individual-decisions/${individualDecision._id}`,
      { choices, reason, duration }
    );

    commit('setCharacters', { characters });
    commit('setIndividualDecisions', { individualDecisions });
    commit('setTeamDecisions', { teamDecisions });
    dispatch('setGroup', { group });
    return Promise.resolve();
  },
  async computeMaxBranchLength(
    { state: { lastComputedBranchLengthGame }, commit, getters },
    { gameId }
  ) {
    if (lastComputedBranchLengthGame === gameId) {
      return;
    }

    const { data } = await axios.get(`/game/demo/${(gameId != null) ? gameId : getters.game._id}/length`);
    commit('setMaxBranchLength', { maxBranchLength: data, gameId });
    return Promise.resolve();
  }
};

const getters = {
  // pass through getters
  // these can be eliminated with map state, but there are namespacing issues in vuex
  /* eslint-disable max-len */

  requiredAssets({ requiredAssets }) { return requiredAssets; },

  // A boolean hack to skip over the watchers in the Dashboard during the wait period in multiplayer
  dashboardProcessingTickDelay({ dashboardProcessingTickDelay }) { return dashboardProcessingTickDelay; },

  // An integer key that is appended to the <router-view> in App.vue's key so that we can refresh game components
  gameRefreshKey({ gameRefreshKey }) { return gameRefreshKey; },

  // A boolean that signifies whether or not, in multiplayer, the player is currently waiting.  Currently only implemented for the dashboard.
  isWaiting({ isWaiting }) { return isWaiting; },
  dateActiveGameCompleted({ dateActiveGameCompleted }) { return dateActiveGameCompleted; },
  updateGroup({ updateGroup }) { return updateGroup; },
  demo({ demo }) { return demo; },
  tempSelectedRole({ tempSelectedRole = {} }) { return tempSelectedRole; },
  slowZoom({ slowZoom }) { return slowZoom; },
  challenges({ challenges = {} }) { return challenges; },
  characters({ characters = {} }) { return characters; },
  game({ game = {} }) { return game; },
  outro({ outro = {} }) { return outro; },
  maxBranchLength({ maxBranchLength = 0 }) { return maxBranchLength; },
  lastChoice({ lastChoice = {} }) { return lastChoice; },
  backToDashboard({ backToDashboard }) { return backToDashboard; },
  skipOutrosEnabled({ skipOutrosEnabled }) { return skipOutrosEnabled; },
  group({ group = {} }) { return group; },
  decisionIndex({ group = {} }, { groupTeamDecisions = [] }) {
    return (group.decisionIndex == null || group.decisionIndex === -1)
      ? (groupTeamDecisions.length - 1)
      : group.decisionIndex;
  },
  individualDecisions({ individualDecisions = {} }) { return individualDecisions; },
  metrics({ metrics = {} }) { return metrics; },
  roles({ roles = {} }) { return roles; },
  teamDecisions({ teamDecisions = {} }) { return teamDecisions; },
  users({ users = {} }) { return users; },
  lastStateBeforeChallengeIntro({ lastStateBeforeChallengeIntro }) { return lastStateBeforeChallengeIntro; },
  teamDecisionBeginCash({ teamDecisionBeginCash }) { return teamDecisionBeginCash; },
  teamDecisionBeginMetrics({ teamDecisionBeginMetrics }) { return teamDecisionBeginMetrics; },
  teamDecisionUpdated({ teamDecisionUpdated }) { return teamDecisionUpdated; },
  resultsViewed({ resultsViewed }) { return resultsViewed; },
  demoStartState() { return '/demo'; },
  startState({ group }) { return `/groups/${group._id}`; },
  gameIntroState({ group }) { return `/groups/${group._id}/intro`; },
  backstorySelectState({ group }) { return `/groups/${group._id}/backstory-select`; },
  avatarSelectState({ group }) { return `/groups/${group._id}/avatar-select`; },
  avatarSelectOutroState({ group }) { return `/groups/${group._id}/avatar-select-outro`; },
  roleSelectState({ group }) { return `/groups/${group._id}/role-select`; },
  roleSelectOutroState({ group }) { return `/groups/${group._id}/role-select-outro`; },
  waitForTeamState({ group }) { return `/groups/${group._id}/wait-for-team`; },
  challengeIntroState({ group }) { return `/groups/${group._id}/challenge/intro`; },
  dashboardState({ group }) { return `/groups/${group._id}/challenge/dashboard`; },
  teamDecisionState({ group }) { return `/groups/${group._id}/challenge/major-decision`; },
  individualDecisionState({ group }) { return `/groups/${group._id}/challenge/minor-decision`; },
  resultsState({ group }) { return `/groups/${group._id}/challenge/results`; },
  challengeOutroState({ group }) { return `/groups/${group._id}/challenge/outro`; },
  gameOutroState({ group }) { return `/groups/${group._id}/outro`; },
  endState({ group }) { return `/groups/${group._id}/end`; },
  errorState({ group }) { return `/groups/${group._id}/error`; },
  dashboardHandledStates(_, { dashboardState, teamDecisionState, resultsState }) {
    return [dashboardState, teamDecisionState, resultsState];
  },
  playerBackgroundStates(_, { waitForTeamState, dashboardState, teamDecisionState }) {
    return [waitForTeamState, dashboardState, teamDecisionState];
  },
  narrativeStates(_, {
    gameIntroState,
    gameOutroState,
    endState,
    avatarSelectOutroState,
    roleSelectOutroState,
    challengeIntroState,
    challengeOutroState,
    individualDecisionState,
    dashboardState,
    teamDecisionState,
    resultsState
  }) {
    return [
      gameIntroState,
      gameOutroState,
      endState,
      avatarSelectOutroState,
      roleSelectOutroState,
      challengeIntroState,
      challengeOutroState,
      individualDecisionState,
      dashboardState,
      teamDecisionState,
      resultsState
    ];
  },
  /* eslint-enable max-len */
  background(_, {
    narrativeStates,
    playerBackgroundStates,
    backstorySelectState,
    avatarSelectState,
    roleSelectState,
    resultsState,
    currentState,
    narrativeBackground,
    playerRole,
    backstorySelectBackground,
    avatarSelectBackground,
    resultsBackground,
    tempSelectedRole,
    teamDecision,
    lastTeamDecision
  }) {
    return (path) => {
      // console.log('1');
      if (narrativeStates.includes(path) && narrativeBackground) return narrativeBackground;
      // console.log('2');
      if (playerBackgroundStates.includes(path)) {
        const td = (currentState === resultsState) ? lastTeamDecision : teamDecision;
        if (td != null && td.backgroundOverride) {
          // console.log('2.1');
          return td.backgroundOverride;
        }
        return playerRole.background;
      }
      // console.log('3');
      if (path === backstorySelectState) return backstorySelectBackground;
      // console.log('4');
      if (path === avatarSelectState) return avatarSelectBackground;
      // console.log('5');
      if (path === resultsState) return resultsBackground;
      // console.log('6');
      if (path === roleSelectState) return tempSelectedRole.background;
      // console.log('7');
      return '';
    };
  },
  startStateRegex() { return /^\/groups\/[^/]+$/; },
  backgroundColor({ group }, { demoStartState, startState, endState, startStateRegex }) {
    return (path) => {
      if (path.match(startStateRegex)) return '';
      if (group._id && [demoStartState, startState, endState].indexOf(path) === -1) {
        return 'black';
      }
      return '';
    };
  },
  entryState(_, { currentState, dashboardState, dashboardHandledStates }) {
    if (dashboardHandledStates.includes(currentState)) return dashboardState;
    return currentState;
  },
  currentState({
    // group,
    // teamDecisionUpdated,
    game,
    resultsViewed
  }, {
    hasSelectedBackstory,
    hasSelectedAvatar,
    hasSelectedRole,
    // otherPlayers,
    allPlayersHere,
    challengeIntroViewed,
    challengeOutroViewed,
    gameIntroViewed,
    gameOutroViewed,
    avatarSelectOutroViewed,
    roleSelectOutroViewed,
    playerDecision,
    individualDecisionIsNext,
    complete,
    lastChallengeOutroViewed,
    lastChallenge,
    currentChallengeIndex,
    // finalTeamDecisionComplete
    // game states
    // entryState,
    gameIntroState,
    backstorySelectState,
    avatarSelectState,
    avatarSelectOutroState,
    roleSelectState,
    roleSelectOutroState,
    waitForTeamState,
    challengeIntroState,
    dashboardState,
    teamDecisionState,
    individualDecisionState,
    resultsState,
    challengeOutroState,
    gameOutroState,
    endState
  }) {
    console.log('***');
    // console.log(currentChallengeIndex);
    if (!(game.doFirstChallengeBeforeIntro && currentChallengeIndex === 0)) {
      if (game.doFirstChallengeBeforeIntro && currentChallengeIndex === 1) {
        if (!resultsViewed) return resultsState;
        if (lastChallenge && !lastChallengeOutroViewed) return challengeOutroState;
      }
      // console.log('intro');
      if (!gameIntroViewed) return gameIntroState;
      // console.log('backstory');
      if (!(game.backstorySelectAfterAvatarSelect) && !hasSelectedBackstory) return backstorySelectState;
      // console.log('avatar');
      if (!hasSelectedAvatar) return avatarSelectState;
      // console.log('backstory');
      if (!(game.backstorySelectAfterAvatarSelectOutroNarrative)
        && game.backstorySelectAfterAvatarSelect
        && !hasSelectedBackstory) {
        return backstorySelectState;
      }
      // console.log('avatar outro');
      if (!avatarSelectOutroViewed) return avatarSelectOutroState;
      // console.log('backstory');
      if (game.backstorySelectAfterAvatarSelectOutroNarrative
        && game.backstorySelectAfterAvatarSelect
        && !hasSelectedBackstory) {
        return backstorySelectState;
      }
    }
    // console.log('role');
    if (!hasSelectedRole) return roleSelectState;
    // console.log('role outro');
    if (!roleSelectOutroViewed) return roleSelectOutroState;
    // console.log('team wait');
    if (!allPlayersHere && hasSelectedAvatar) return waitForTeamState;

    console.log('a');
    if (!resultsViewed) return resultsState;
    console.log('b');
    if (individualDecisionIsNext) return individualDecisionState;

    console.log('c');
    if (complete) {
      console.log('d');
      if (!challengeOutroViewed) {
        return challengeOutroState;
      }
      console.log('e');
      if (!gameOutroViewed) {
        return gameOutroState;
      }
      console.log('f');
      return endState;
    }

    console.log('g');
    if (!lastChallengeOutroViewed && lastChallenge) {
      return challengeOutroState;
    }

    console.log('h');
    if (!challengeIntroViewed) return challengeIntroState;

    console.log('j');
    if (playerDecision) return teamDecisionState;

    // console.log(group);

    console.log('k');

    // if (group.players.length > 1) {
    //   if (!challengeOutroViewed) {
    //     return challengeOutroState;
    //   }
    //   if (!gameOutroViewed) {
    //     return gameOutroState;
    //   }
    //   return endState; // TODO: some special default state?
    // }

    return dashboardState;
  },
  native({ game: { theme } }) {
    if (theme) {
      return theme === 'native';
    }
    return false;
  },
  starfighter({ game: { theme } }) {
    if (!theme) { // no theme presumes starfighter
      return true;
    }
    return theme === 'starfighter';
  },
  singlePlayer({ group: { players = [] } = {} }) {
    return players.length === 1;
  },
  singleRole({ group: { roles = [] } = {} }) {
    return roles.length === 1;
  },
  status({ group: { status } = {} }) {
    return status;
  },
  complete(_, { status }) {
    return status === 'complete';
  },
  multiplayer({ group: { players = [] } = {} }) {
    return players.length > 1;
  },
  groupPlayersById({ group: { players = [] } = {} }) {
    return players.reduce((acc, player) => {
      acc[player._id] = player;
      return acc;
    }, {});
  },
  myPlayer(_, { groupPlayersById, me }) {
    return groupPlayersById[me._id] || {};
  },
  myProgress({
    game: { challenges = [] } = {},
    group: { teamDecisions = [] } = {}
  }, {
    currentState = {},
    endState = {},
    gameIntroViewed = false,
    currentChallengeIndex = 0,
    challengeIntroViewed = false,
    myPlayer: { individualDecisions = [] } = {},
    maxBranchLength = 0
  }) {
    if (currentState === endState) return 100;
    // TODO: single-decision assumption
    const completeDecisions = teamDecisions.filter(d => d.decisions[0].completed != null);
    const completeIndDecisions = individualDecisions.filter(id => id.completed != null);
    let progress =
      completeIndDecisions.length
      + (completeDecisions.length)
      + currentChallengeIndex
      + (gameIntroViewed ? 0.5 : 0)
      + (challengeIntroViewed ? 0.5 : 0);
    progress /= (maxBranchLength + challenges.length + 1);
    progress *= 100;
    progress = Math.max(0, progress);
    progress = Math.min(100, progress);
    return progress;
  },
  unreadNotificationCount(_, { myPlayer: { unreadNotificationCount } }) {
    return ((unreadNotificationCount == null) ? 0 : unreadNotificationCount);
  },
  proxyGroupRole({ proxyRoleId }, { groupRolesById }) {
    return groupRolesById[proxyRoleId];
  },
  proxyRole({ roles }, { proxyGroupRole = {} }) {
    return roles[proxyGroupRole._id];
  },
  // can be undefined
  proxyAvatar({ proxyRoleId, group: { avatars = [] } = {}, characters }) {
    const avatar = proxyRoleId && avatars.find(({ role }) => role && proxyRoleId === role) || {};
    return characters[avatar._id];
  },
  groupRolesById({ group: { roles = [] } = {} }) {
    return roles.reduce((acc, role) => {
      acc[role._id] = role;
      return acc;
    }, {});
  },
  groupRolesByPlayer({ group: { roles = [] } = {} }) {
    return roles.reduce((acc, role) => {
      if (role.player) acc[role.player] = role;
      return acc;
    }, {});
  },
  groupRolesByPlayedBy({ group: { roles = [] } = {} }) {
    return roles.reduce((acc, role) => {
      if (role.playedBy) acc[role.playedBy] = role;
      return acc;
    }, {});
  },
  groupTeamDecision({ group: { teamDecisions = [] } = {} }, { decisionIndex }) {
    const groupTeamDecision = teamDecisions[decisionIndex];
    return groupTeamDecision || {};
  },
  teamDecision({ teamDecisions }, { groupTeamDecision }) {
    return teamDecisions[groupTeamDecision._id] || {};
  },
  groupDecisions(_, { groupTeamDecision: { decisions = [] } = {} }) {
    return decisions;
  },
  groupTeamDecisions({ group: { teamDecisions = [] } = {} }) {
    return teamDecisions;
  },
  groupNotifications(_, {
    users,
    teamDecisions,
    groupTeamDecisions,
    roles,
    // metrics,
    avatarsByPlayerId
  }) {
    const selectString = (strings) => {
      for (let i = 0; i < strings.length; i++) {
        if (strings[i] && strings[i] !== '') return strings[i];
      }
      return null;
    };

    const notif = [];
    // gather all subdecisions that are completed and not flagged fake/wrong
    groupTeamDecisions.forEach((d) => {
      const td = teamDecisions[d._id];
      // skip any td marked as feedback
      if ((!(d.feedback) || (td && !(td.feedback))) && d.decisions) {
        const subdecisions = d.decisions.filter(
          ({ fake, wrong, player, completed }) => !fake && !wrong && player && completed
        );
        if (subdecisions && subdecisions.length) {
          // console.log(subdecisions);
          // console.log(td);
          subdecisions.forEach((sd) => {
            // find subdecision definition if necessary and possible
            const tdsd = ((!(sd.type) || ['matching', 'scale', 'matrix'].includes(sd.type)) && td)
              ? td.decisions.find(({ _id }) => `${_id}` === `${sd._id}`)
              : null;
              // grab decision title
            let decisionTitle = '';
            if (sd.type) {
              decisionTitle =
                (['sliders', 'roleAllocation', 'projectAllocation'].includes(sd.type))
                  ? ''
                  : (selectString([sd.activityWindowTitle, sd.reportTitle, sd.title])).replaceAll(/font-size:[^;]*;/g, '');
            } else if (tdsd && tdsd.type) {
              decisionTitle =
                (['sliders', 'roleAllocation', 'projectAllocation'].includes(tdsd.type))
                  ? ''
                  : (selectString([tdsd.activityWindowTitle, tdsd.reportTitle, tdsd.title])).replaceAll(/font-size:[^;]*;/g, '');
            }
            // grab player name
            const u = users[sd.player];
            const playerName = ((u) ? u.firstName || u.email : '');
            // grab player character
            const character = (avatarsByPlayerId[sd.player] || {}).character;
            // grab decision role background
            const dr = sd.role ? roles[sd.role] : ((tdsd && tdsd.role) ? roles[tdsd.role] : null);
            const backgroundBanner = ((dr) ? dr.backgroundBanner : '');
            // grab choice titles and effects
            const choices = sd.choices;
            if ((!tdsd || (tdsd.choices && tdsd.choices.length)) && choices && choices.length) {
              choices.forEach((c) => {
                const tdc = tdsd ? tdsd.choices.find(({ _id }) => `${_id}` === `${c._id}`) : c;
                if (tdc) {
                  c.title = ((tdc.title) ? tdc.title.replaceAll(/font-size:[^;]*;/g, '') : '');
                  c.effectText = '';
                  if (sd.type === 'sliders' || (tdsd && tdsd.type === 'sliders')) {
                    c.effectText = `${c.sliderValue}`;
                  } else if (tdsd && tdsd.type === 'matrix' && tdsd.categories && tdsd.categories.length) {
                    const selectedCategories = (c.categoryIds || []).map(
                      ({ _id }) => tdsd.categories.find(tdsdCat => `${tdsdCat._id}` === `${_id}`)
                    );
                    selectedCategories.forEach((selectedCategory) => {
                      if (selectedCategory && selectedCategory.name) {
                        if (c.effectText) c.effectText += '; ';
                        c.effectText +=
                          `${(selectedCategory.displayName || '').replaceAll(/font-size:[^;]*;/g, '') || selectedCategory.name}`;
                      }
                    });
                  } else if (tdsd && ['matching', 'scale'].includes(tdsd.type) && tdsd.categories && tdsd.categories.length) {
                    const selectedCategory = tdsd.categories.find(tdsdCat => `${tdsdCat._id}` === `${c.categoryId}`);
                    if (selectedCategory && selectedCategory.name) {
                      c.effectText =
                        `${(selectedCategory.displayName || '').replaceAll(/font-size:[^;]*;/g, '') || selectedCategory.name}`;
                    }
                  } else if (sd.type === 'roleAllocation' || (tdsd && tdsd.type === 'roleAllocation')) {
                    if (c.allocateToRole) {
                      // grab target role title
                      const r = roles[c.allocateToRole];
                      c.title = (r) ? r.title.replaceAll(/font-size:[^;]*;/g, '') : '';
                    }
                    c.effectText = (c.allocation < 0)
                      ? `-$${Math.abs(c.allocation)}`
                      : `$${c.allocation}`;
                  } else if (sd.type === 'projectAllocation' || (tdsd && tdsd.type === 'projectAllocation')) {
                    c.effectText = (c.allocation < 0)
                      ? `-$${Math.abs(c.allocation)}`
                      : `$${c.allocation}`;
                  } else { // choice, multiselect, survey, etc.
                    // Switching from these cached deltas to score snapshots instead.
                    // Leaving this here in case we ever want to reenable this.
                    // // grab cash adjustment
                    // if (tdc.cashAdjustment) {
                    //   c.effectText = (tdc.cashAdjustment < 0)
                    //     ? `-$${Math.abs(tdc.cashAdjustment)}`
                    //     : `+$${tdc.cashAdjustment}`;
                    // }
                    // // grab metric adjustments
                    // if (tdc.metricAdjustments && tdc.metricAdjustments.length) {
                    //   tdc.metricAdjustments.forEach((ma) => {
                    //     // grab metric title
                    //     const m = metrics[ma.metric];
                    //     if (m && ma.adjustment != null) {
                    //       c.effectText += (ma.adjustment < 0)
                    //         ? `, ${m.title.replaceAll(/font-size:[^;]*;/g, '')} ${ma.adjustment}`
                    //         : `, ${m.title.replaceAll(/font-size:[^;]*;/g, '')} +${ma.adjustment}`;
                    //     }
                    //   });
                    // }
                    // if (!(tdc.cashAdjustment) && c.effectText.length > 2) {
                    //   c.effectText = c.effectText.substring(2); // chop off the starting ', '
                    // }
                  }
                }
              });
              // Switching from these cached deltas to score snapshots instead.
              // Leaving this here in case we ever want to reenable this.
              // (tdsd ? (tdsd.choices || []) : (sd.unselectedChoices || [])).forEach(
              //   ({ _id, title, unselectedMetricAdjustments }) => {
              //     if (unselectedMetricAdjustments && unselectedMetricAdjustments.length
              //       && !choices.some(c => `${_id}` === `${c._id}`)) {
              //       const uc = {
              //         _id,
              // eslint-disable-next-line max-len
              //         title: `Did not choose: ${title ? title.replaceAll(/font-size:[^;]*;/g, '') : ''}`,
              //         effectText: ''
              //       };
              //       unselectedMetricAdjustments.forEach((uma) => {
              //         // grab metric title
              //         const m = metrics[uma.metric];
              //         if (m && uma.adjustment != null) {
              //           uc.effectText += (uma.adjustment < 0)
              //             ? `, ${m.title.replaceAll(/font-size:[^;]*;/g, '')} ${uma.adjustment}`
              //             : `, ${m.title.replaceAll(/font-size:[^;]*;/g, '')} +${uma.adjustment}`;
              //         }
              //       });
              //       choices.push(uc);
              //     }
              //   }
              // );
            }
            const completed =
              (sd.completed && sd.completed.getTime == null)
                ? new Date(sd.completed)
                : sd.completed;
            const type = sd.type || tdsd.type;
            notif.push({
              _id: d._id,
              playerName,
              character,
              backgroundBanner,
              decisionTitle,
              type,
              choices,
              completed,
              endCash: sd.endCash,
              endRolesCash: sd.endRolesCash,
              endMetrics: sd.endMetrics
            });
          });
        }
      }
    });
    // sort by completed timestamp
    notif.sort((a, b) => b.completed.getTime() - a.completed.getTime());
    return notif;
  },
  /** final team decision of the game */
  finalTeamDecisionComplete(_, { groupDecisions, me }) {
    return groupDecisions.some(d => d.completed && me._id === d.player);
    // locally complete rather than group-wide complete, to allow players to
    // finish the game before the whole group does.
    // return groupDecisions.every(d => d.completed);
  },
  decisions(_, { teamDecision: { decisions = [], feedback = false } = {} }) {
    decisions.forEach((d) => { d.feedback = feedback; });
    return decisions;
  },
  groupDecisionsById(_, { groupDecisions }) {
    return groupDecisions.reduce((acc, decision) => {
      acc[decision._id] = decision;
      return acc;
    }, {});
  },
  groupDecisionsByPlayerId(_, { groupDecisions }) {
    return groupDecisions.reduce((acc, decision) => {
      if (decision.player) {
        acc[decision.player] = decision;
      }
      return acc;
    }, {});
  },
  decisionsById(_, { decisions = [] }) {
    return decisions.reduce((acc, decision) => {
      acc[decision._id] = decision;
      return acc;
    }, {});
  },
  decisionsByRole(_, { decisions = [] }) {
    return decisions.reduce((acc, decision) => {
      acc[decision.role] = decision;
      return acc;
    }, {});
  },
  lastGroupTeamDecision({
    group: { teamDecisions = [] } = {}
  }, {
    finalTeamDecisionComplete,
    decisionIndex
  }) {
    if (finalTeamDecisionComplete && teamDecisions.length > 0) {
      return teamDecisions[teamDecisions.length - 1];
    }
    if (teamDecisions.length < 2) return;
    const groupTeamDecision = teamDecisions[decisionIndex - 1];
    return groupTeamDecision;
  },
  lastTeamDecision({ teamDecisions }, { lastGroupTeamDecision }) {
    if (!lastGroupTeamDecision) return;
    return teamDecisions[lastGroupTeamDecision._id];
  },
  lastGroupDecisions(_, { lastGroupTeamDecision }) {
    if (!lastGroupTeamDecision) return;
    return lastGroupTeamDecision.decisions;
  },
  lastDecisions(_, { lastTeamDecision }) {
    if (!lastTeamDecision) return;
    return lastTeamDecision.decisions;
  },
  lastGroupDecisionsById(_, { lastGroupDecisions }) {
    if (!lastGroupDecisions) return;
    return lastGroupDecisions.reduce((acc, decision) => {
      acc[decision._id] = decision;
      return acc;
    }, {});
  },
  lastDecisionsByRole(_, { lastDecisions }) {
    if (!lastDecisions) return;
    return lastDecisions.reduce((acc, decision) => {
      acc[decision.role] = decision;
      return acc;
    }, {});
  },
  narrator({ group, game, characters }) {
    if (group.narratorOverride) {
      return characters[group.narratorOverride] || {};
    }
    return characters[game.narrator] || {};
  },
  gameEndCharacter({ game, characters }, { activeEnvironment }) {
    if (activeEnvironment && activeEnvironment.gameEndCharacter) {
      return characters[activeEnvironment.gameEndCharacter] || {};
    }
    if (game && game.gameEndCharacter) {
      return characters[game.gameEndCharacter] || {};
    }
    return null;
  },
  backstorySelectBackground({ game }) {
    return game.backstorySelectBackground || '';
  },
  avatarSelectBackground({ game }) {
    return game.avatarSelectBackground || '';
  },
  resultsBackground({ game }, { playerRole }) {
    return game.playerResultsBackground ? playerRole.background : game.resultsBackground;
  },
  ageGroups({ game }) {
    return game.ageGroups || [];
  },
  avatars({ group: { avatars = [] }, characters }) {
    return avatars.map(({ _id, player, role }) => ({
      _id,
      character: characters[_id],
      player,
      role
    }));
  },
  avatarsByAgeGroup({ game }, { avatarsByCharacterId }) {
    const aBAG = {};
    game.avatars.filter(a => a._id && a.ageGroup).forEach((avatar) => {
      if (aBAG[avatar.ageGroup] == null) {
        aBAG[avatar.ageGroup] = [avatarsByCharacterId[avatar._id]];
      } else {
        aBAG[avatar.ageGroup].push(avatarsByCharacterId[avatar._id]);
      }
    });
    game.avatars.filter(a => a._id && !(a.ageGroup)).forEach((avatar) => {
      Object.keys(aBAG).forEach((key) => {
        if (Array.isArray(aBAG[key])) {
          aBAG[key].push(avatarsByCharacterId[avatar._id]);
        }
      });
    });
    return aBAG;
  },
  avatarsByCharacterId(_, { avatars = [] }) {
    return avatars.filter(a => a._id).reduce((acc, avatar) => {
      acc[avatar._id] = avatar;
      return acc;
    }, {});
  },
  // use for chat, only real player avatars
  avatarsByPlayerId(_, { avatars = [] }) {
    return avatars.filter(a => a.player).reduce((acc, avatar) => {
      acc[avatar.player] = avatar;
      return acc;
    }, {});
  },
  selectedAvatar({ group: { avatars = [] }, characters }, { me }) {
    const { _id } = avatars.find(({ player }) => player === me._id) || {};
    return characters[_id] || {};
  },
  hasSelectedAvatar(_, { selectedAvatar }) {
    return !!selectedAvatar._id;
  },
  hasSelectedBackstory({ game }, { myPlayer }) {
    return (!(game.backstories) || (game.backstories && game.backstories.length === 0)) || myPlayer.backstory;
  },
  // player or proxy player
  playerGroupRole({ proxyRoleId }, { groupRolesById, groupRolesByPlayer, me }) {
    return groupRolesById[proxyRoleId] || groupRolesByPlayer[me._id] || {};
  },
  // player or proxy player
  playerRole({ roles }, { playerGroupRole }) {
    const r = roles[playerGroupRole._id] || {};
    if (playerGroupRole.backgroundOverride) {
      r.background = playerGroupRole.backgroundOverride;
    }
    return r;
  },
  hasSelectedRole(_, { playerRole }) {
    return !!playerRole._id;
  },
  // can be undefined
  // this will change for voting decisions
  // player or proxy player
  playerDecision(_, { decisionsByRole, groupDecisionsById, playerRole }) {
    if (!decisionsByRole) return;
    const decision = decisionsByRole[playerRole._id];
    if (!decision) return;
    const groupDecision = groupDecisionsById[decision._id];
    return !!groupDecision && !groupDecision.completed && decision;
  },
  playerGroupDecision(_, { decisionsByRole, groupDecisionsById, playerRole }) {
    if (!decisionsByRole) return;
    const decision = decisionsByRole[playerRole._id];
    if (!decision) return;
    const groupDecision = groupDecisionsById[decision._id];
    return groupDecision;
  },
  playerDecisionHistory({ teamDecisions }, { playerGroupDecisionHistory }) {
    // console.log(teamDecisions);
    // console.log(playerGroupDecisionHistory);
    const pdHistory = [];
    if (playerGroupDecisionHistory.length > 0) {
      pdHistory.push(
        ...(playerGroupDecisionHistory.map(
          gd => teamDecisions[gd.parentTeamDecision].decisions.find(tdd => `${tdd._id}` === `${gd._id}`)
        ))
      );
    }
    return pdHistory;
  },
  playerGroupDecisionHistory({ group }, { myPlayer }) {
    const pgdHistory = [];
    const decisionIndex =
        (group.decisionIndex == null) ? (group.teamDecisions.length - 1) : group.decisionIndex;
    if (decisionIndex > 0) {
      const teamDecisionHistory = group.teamDecisions.slice(0, decisionIndex);
      teamDecisionHistory.forEach(({ _id, decisions }) => {
        const pastPlayerGroupDecision = decisions.find(({ player }) => `${player}` === `${myPlayer._id}`);
        if (pastPlayerGroupDecision != null) {
          pastPlayerGroupDecision.parentTeamDecision = _id;
          pgdHistory.push(pastPlayerGroupDecision);
        }
      });
    }
    return pgdHistory;
  },
  playerDecisionCompleted(_, { groupDecisionsByPlayerId, myPlayer }) {
    if (!groupDecisionsByPlayerId) return false;
    if (!myPlayer) return false;
    const groupDecision = groupDecisionsByPlayerId[myPlayer._id];
    if (!groupDecision) return false;
    return groupDecision.completed;
  },
  playerLastDecision(_, { lastDecisionsByRole, lastGroupDecisionsById, playerRole }) {
    if (!lastDecisionsByRole) return;
    const decision = lastDecisionsByRole[playerRole._id];
    if (!decision) return;
    const groupDecision = lastGroupDecisionsById[decision._id];
    return !!groupDecision && decision;
  },
  playerLastGroupDecision(_, { lastDecisionsByRole, lastGroupDecisionsById, playerRole }) {
    if (!lastDecisionsByRole) return;
    const decision = lastDecisionsByRole[playerRole._id];
    if (!decision) return;
    const groupDecision = lastGroupDecisionsById[decision._id];
    return groupDecision;
  },
  // player or proxy player
  playerNextDecision(_, { playerDecision, individualDecision }) {
    return playerDecision || individualDecision;
  },
  // can be undefined
  playerFirstIncompleteIndividualDecision(_, { myPlayer }) {
    if (myPlayer.individualDecisions == null) return null;
    return myPlayer.individualDecisions.find(({ completed, wrong }) => !completed || wrong);
  },
  individualDecision({ individualDecisions }, { playerFirstIncompleteIndividualDecision = {} }) {
    if (individualDecisions == null) return null;
    if (playerFirstIncompleteIndividualDecision == null) return null;
    if (playerFirstIncompleteIndividualDecision._id == null) return null;
    return individualDecisions[playerFirstIncompleteIndividualDecision._id];
  },
  // for determining next game state
  noDecisionsMade(_, { groupDecisions }) {
    return groupDecisions.every(({ completed }) => !completed);
  },
  individualDecisionFromLastTeamDecision(_, {
    playerFirstIncompleteIndividualDecision,
    lastTeamDecision,
  }) {
    return (lastTeamDecision && playerFirstIncompleteIndividualDecision &&
      playerFirstIncompleteIndividualDecision.teamDecision === lastTeamDecision._id);
  },
  // for determining next game state
  individualDecisionIsNext(_, {
    individualDecisionFromLastTeamDecision,
    finalTeamDecisionComplete,
    individualDecision
  }) {
    // both individualDecisionFromLastTeamDecision and individualDecision look for the first
    // incomplete individual decision loaded.
    // TODO: not sure the second part of this is needed anymore but it shouldn't be harmful.
    return individualDecisionFromLastTeamDecision
      || (finalTeamDecisionComplete && individualDecision);
  },
  otherRoles({ group: { roles = [] } = {} }, { me }) {
    return roles.filter(({ player }) => player !== me._id);
  },
  allPlayers(
    { group, characters, roles },
    { groupRolesById, groupRolesByPlayer, decisionsByRole, groupDecisionsById }
  ) {
    return (group.avatars == null) ? [] : group.avatars
      .filter(({ player, role }) => player || role)
      .map(({ _id, player, role }) => {
        const groupRole = groupRolesByPlayer[player] || groupRolesById[role] || {};
        const decision = decisionsByRole[groupRole._id];
        const groupDecision = groupDecisionsById[decision && decision._id];
        return {
          _id: player,
          character: characters[_id] || {},
          role: roles[groupRole._id] || {},
          groupRole,
          decision,
          groupDecision
        };
      });
  },
  otherPlayers(
    { group, characters, roles, proxyRoleId },
    { me, groupRolesById, groupRolesByPlayer, decisionsByRole, groupDecisionsById }
  ) {
    return (group.avatars == null) ? [] : group.avatars
      .filter(({ player, role }) => player || role)
      .map(({ _id, player, role }) => {
        const groupRole = groupRolesByPlayer[player] || groupRolesById[role] || {};
        const decision = decisionsByRole[groupRole._id];
        const groupDecision = groupDecisionsById[decision && decision._id];
        return {
          _id: player,
          character: characters[_id] || {},
          role: roles[groupRole._id] || {},
          groupRole,
          decision,
          groupDecision
        };
      })
      .filter(({ groupRole: { _id, player } }) => (
        proxyRoleId ? _id !== proxyRoleId : player !== me._id
      ));
  },
  fakeOtherPlayers(_, { me, avatarsByAgeGroup, avatars }) {
    // find group of player
    const avatarGroupIds = Object.keys(avatarsByAgeGroup);
    let playerAvatarGroup = avatars;
    if (avatarGroupIds && avatarGroupIds.length) {
      const playerAvatarGroupId = avatarGroupIds.find((avatarGroupId) => {
        const avatarGroup = avatarsByAgeGroup[avatarGroupId];
        return avatarGroup.some(a => a.player === me._id);
      });
      playerAvatarGroup = (playerAvatarGroupId != null
        ? avatarsByAgeGroup[playerAvatarGroupId]
        : avatarsByAgeGroup[avatarGroupIds[0]]);
    }
    // use that avatar group with player filtered out
    const otherAvatars = playerAvatarGroup.filter(a => a.player !== me._id);
    const fakeResponses = shuffle([
      'Right away.',
      'I\'m on it.',
      'We\'ll see what that does.',
      'Good idea.'
    ]);

    return [0, 1, 2, 3].map(i => ({
      character: (otherAvatars[i] != null ? otherAvatars[i].character : null),
      role: { title: '' },
      fake: true,
      fakeResponse: fakeResponses[i]
    }));
  },
  allPlayersHere(
    { group },
    { allPlayers }
  ) {
    return group && group.players && allPlayers
      && (allPlayers.length >= group.players.length)
      && allPlayers.every(({ character: { image }, role: { _id } }) => image && _id);
  },
  lastOtherPlayers(
    { group, characters, roles, proxyRoleId },
    { me, groupRolesById, groupRolesByPlayer, lastDecisionsByRole, lastGroupDecisionsById }
  ) {
    return group.avatars
      .filter(({ player, role }) => player || role)
      .map(({ _id, player, role }) => {
        const groupRole = groupRolesByPlayer[player] || groupRolesById[role] || {};
        const decision = lastDecisionsByRole && lastDecisionsByRole[groupRole._id];
        const groupDecision =
          lastGroupDecisionsById &&
          lastGroupDecisionsById[decision && decision._id];
        return {
          character: characters[_id] || {},
          role: roles[groupRole._id] || {},
          groupRole,
          decision,
          groupDecision
        };
      })
      .filter(({ groupRole: { _id, player } }) => (
        proxyRoleId ? _id !== proxyRoleId : player !== me._id
      ));
  },
  challenge({ challenges }, { groupTeamDecision }) {
    return challenges[groupTeamDecision.challenge] || {};
  },
  currentChallengeIndex({ group }, { groupTeamDecision }) {
    return (group && group.challenges)
      ? (group.challenges.findIndex(({ _id }) => _id === groupTeamDecision.challenge))
      : 0;
  },
  lastChallenge({ group, challenges }, { currentChallengeIndex }) {
    if (currentChallengeIndex <= 0) return;
    const lastChallengeId = group.challenges[currentChallengeIndex - 1]._id;
    return challenges[lastChallengeId];
  },
  myPlayerCurrentChallenge(_, { myPlayer, challenge }) {
    if (myPlayer.challenges == null) return null;
    return myPlayer.challenges.find(({ _id }) => _id === challenge._id);
  },
  myPlayerLastChallenge(_, { myPlayer, lastChallenge }) {
    if (myPlayer.challenges == null || !lastChallenge) return null;
    return myPlayer.challenges.find(({ _id }) => _id === lastChallenge._id);
  },
  challengeIntroViewed(_, { myPlayerCurrentChallenge }) {
    if (myPlayerCurrentChallenge == null) return false;
    return myPlayerCurrentChallenge.introViewed;
  },
  lastChallengeIntroViewed(_, { lastChallenge, myPlayerLastChallenge }) {
    if (!lastChallenge) return true;
    if (myPlayerLastChallenge == null) return false;
    return myPlayerLastChallenge.introViewed;
  },
  challengeOutroViewed(_, { myPlayerCurrentChallenge }) {
    if (myPlayerCurrentChallenge == null) return false;
    return myPlayerCurrentChallenge.outroViewed;
  },
  lastChallengeOutroViewed(_, { lastChallenge, myPlayerLastChallenge }) {
    if (!lastChallenge) return true;
    if (myPlayerLastChallenge == null) return false;
    return !!(myPlayerLastChallenge.outroViewed);
  },
  gameIntroViewed(_, { myPlayer }) {
    return myPlayer.gameIntroViewed;
  },
  gameOutroViewed(_, { myPlayer }) {
    return myPlayer.gameOutroViewed;
  },
  avatarSelectOutroViewed(_, { myPlayer }) {
    return myPlayer.avatarSelectOutroViewed;
  },
  roleSelectOutroViewed(_, { myPlayer }) {
    return myPlayer.roleSelectOutroViewed;
  },
  isFirstChallenge({ game }, { challenge }) {
    const [{ _id }] = game.challenges;
    return _id === challenge._id;
  },
  /** TODO: better check would be "groupTeamDecision index is 0" but it's not referenced anywhere so I'm leaving it for now */
  isFirstDecision(_, { isFirstChallenge, challenge, groupTeamDecision }) {
    return isFirstChallenge &&
      challenge.startingTeamDecision === groupTeamDecision._id;
  },
  displayMetrics({
    group,
    metrics,
    resultsViewed,
  }, {
    endChallengeDisplayMetrics,
    endDecisionDisplayMetrics,
    firstDecisionOfNewChallenge,
    lastChallengeOutroViewed,
  }) {
    if (!resultsViewed) {
      return endDecisionDisplayMetrics;
    }

    if (firstDecisionOfNewChallenge && !lastChallengeOutroViewed) {
      return endChallengeDisplayMetrics;
    }

    return group.metrics.map(({ _id, value, hidden }) => ({
      metric: metrics[_id],
      value,
      hidden
    }));
  },
  displayMetricsByReferenceId(_, {
    displayMetrics,
  }) {
    const metMap = new Map();
    displayMetrics.forEach((dm) => {
      if (dm.metric && dm.metric.referenceId) metMap.set(dm.metric.referenceId, dm);
    });
    return metMap;
  },
  playerResponsesByReferenceId(_, {
    groupTeamDecisions,
  }) {
    const metMap = new Map();
    groupTeamDecisions.forEach(({ decisions = [] }) => {
      decisions.forEach((decision) => {
        if (decision && decision.choices && decision.choices.length) {
          if (decision.referenceId) {
            if (decision.type === 'freeResponse') {
              metMap.set(decision.referenceId, decision.reason);
            } else {
              metMap.set(decision.referenceId, decision.choices[0].title);
            }
          }
          if (decision.type === 'form') {
            decision.choices.forEach((c) => {
              if (c && c.referenceId && c.title) {
                metMap.set(c.referenceId, c.title);
              }
            });
          }
        }
      });
    });
    return metMap;
  },
  firstDecisionOfNewChallenge(_, { groupTeamDecision, lastGroupTeamDecision }) {
    return lastGroupTeamDecision &&
      lastGroupTeamDecision.challenge !== groupTeamDecision.challenge;
  },
  lastGroupChallenge({ group }, { lastChallenge }) {
    if (!lastChallenge) return;
    return group.challenges.find(({ _id }) => _id === lastChallenge._id);
  },
  endDecisionDisplayCash(_, { playerLastGroupDecision }) {
    if (!playerLastGroupDecision) return 0;
    return (playerLastGroupDecision.endCash || 0) +
    playerLastGroupDecision.endRolesCash.reduce((acc, { cash = 0 }) => acc + cash, 0);
  },
  endDecisionDisplayMetrics({ metrics }, { playerLastGroupDecision }) {
    if (!playerLastGroupDecision) return;
    return playerLastGroupDecision.endMetrics.map(({ _id, value, hidden }) => ({
      metric: metrics[_id],
      value,
      hidden
    }));
  },
  endChallengeDisplayCash(_, { lastGroupChallenge }) {
    if (!lastGroupChallenge) return 0;
    return (lastGroupChallenge.endCash || 0) +
      lastGroupChallenge.endRolesCash.reduce((acc, { cash = 0 }) => acc + cash, 0);
  },
  endChallengeDisplayMetrics({ metrics }, { lastGroupChallenge }) {
    if (!lastGroupChallenge) return;
    return lastGroupChallenge.endMetrics.map(({ _id, value, hidden }) => ({
      metric: metrics[_id],
      value,
      hidden
    }));
  },
  cash({ group }) {
    return group.cash || 0;
  },
  displayCash({
    group,
    resultsViewed,
  }, {
    endChallengeDisplayCash,
    endDecisionDisplayCash,
    firstDecisionOfNewChallenge,
    lastChallengeOutroViewed,
    // playerGroupRole,
    // playerDecision,
  }) {
    // Disabled for now in light of SCS behavior
    // if (playerGroupRole.useRoleCash && (!playerDecision ||
    //     playerDecision.type !== 'roleAllocation')) {
    //   return playerGroupRole.cash;
    // }

    if (!resultsViewed) {
      return endDecisionDisplayCash;
    }

    if (firstDecisionOfNewChallenge && !lastChallengeOutroViewed) {
      return endChallengeDisplayCash;
    }

    return (group.cash || 0);// + group.roles.reduce((acc, { cash = 0 }) => acc + cash, 0);
  },
  displayTeamDecisionBeginMetrics({ teamDecisionBeginMetrics, metrics }) {
    return teamDecisionBeginMetrics.map(({ _id, value, hidden }) => ({
      metric: metrics[_id],
      value,
      hidden
    }));
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/game/game.js